import { useLanguageCode } from '@mews-commander/core';
import { AssistantSearchType, useRepositoryQuery } from '@mews-commander/data-access';
import { getCurrentEnterpriseChainId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { SearchType } from '../assistantSearchTypes';

export enum SummaryComponent {
    CustomerInfo = 'CustomerInfo',
    Reservations = 'Reservations',
    Bills = 'Bills',
    SmartTips = 'SmartTips',
    CustomerInsights = 'CustomerInsights',
}

const searchTypeConverter = {
    [SearchType.Customer]: AssistantSearchType.Customer,
    [SearchType.Reservation]: AssistantSearchType.Reservation,
    [SearchType.Bill]: AssistantSearchType.Bill,
    [SearchType.Command]: AssistantSearchType.Command,
    [SearchType.ProductServiceOrder]: AssistantSearchType.ProductServiceOrder,
    [SearchType.Resource]: AssistantSearchType.Resource,
    [SearchType.ResourceBlock]: AssistantSearchType.ResourceBlock,
    [SearchType.AvailabilityBlock]: AssistantSearchType.AvailabilityBlock,
    [SearchType.ReservationGroup]: AssistantSearchType.ReservationGroup,
    [SearchType.Company]: AssistantSearchType.Company,
    [SearchType.City]: AssistantSearchType.City,
    [SearchType.TravelAgency]: AssistantSearchType.TravelAgency,
    [SearchType.Locations]: AssistantSearchType.Locations,
    [SearchType.EnterpriseProfile]: AssistantSearchType.EnterpriseProfile,
    [SearchType.Navigation]: AssistantSearchType.Navigation,
    [SearchType.RoutingRule]: AssistantSearchType.RoutingRule,
};

export const useSummarySectionOrderQuery = (searchType: SearchType, entityId: string) => {
    const languageCode = useLanguageCode();
    const chainId = useCommanderSelector<string>(getCurrentEnterpriseChainId);

    return useRepositoryQuery('assistantSummary', 'getTemplate', {
        languageCode,
        chainId,
        entityId,
        searchType: searchTypeConverter[searchType],
    });
};
